module.exports = __webpack_public_path__ + "static/media/09.ffac70e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/09.jpg
// module id = 184
// module chunks = 0